import { Skeleton } from '@/components/ui/skeleton'

/**
 * Space 页面内容区域骨架屏
 * 显示标题 + 模板网格（10个模板，5列）
 */
export function SpaceContentSkeleton() {
  return (
    <div className="mt-[clamp(20px,2vw,32px)] w-full max-w-full px-[clamp(8px,1vw,16px)]">
      {/* 标题 skeleton */}
      <Skeleton className="mb-[clamp(10px,1vw,16px)] h-6 w-32" />
      {/* 模板网格 skeleton - 2 列移动端，5 列桌面端 */}
      <div className="grid w-full max-w-full grid-cols-2 gap-4 @md:grid-cols-3 @lg:grid-cols-4 @xl:grid-cols-5">
        {Array.from({ length: 10 }).map((_, index) => (
          <div key={index} className="flex flex-col">
            {/* 视频卡片 skeleton - 16:9 比例 */}
            <Skeleton className="aspect-video w-full rounded-[6px]" />
            {/* 标题 skeleton */}
            <Skeleton className="mt-2 h-6 w-3/4" />
            {/* 描述 skeleton */}
            <Skeleton className="mt-1 h-5 w-full" />
          </div>
        ))}
      </div>
    </div>
  )
}
